<app-navbar-style-three></app-navbar-style-three>
<div class="bg-image " style="font-family: 'Li Ador Noirrit SemiBold';">
    <div class="container-fluid ">
        <div class="mt-4 mb-4" *ngIf="!fetchinData">

            <div class="row">
                <div class="col-md-12">
                    <div style="min-height: auto;">


                        <div class="container-fluid" *ngIf="selectedItem && selectedItem === 'governing-body'">
                            <ng-container *ngIf="GBs == null" class="spinner-overlay">
                                <span class="fetching-data-text">No Data Found</span>
                            </ng-container>
                            <div class="row justify-content-center">
                                <div class="title mx-auto text-center"
                                    style="height: 200px; width: 400px; padding-top: 0%;">
                                    <h2 style="color: black !important; padding-top: 70px;">পরিচালনা পর্ষদ</h2>
                                </div>
                            </div>

                            <div class="row justify-content-center mt-4" *ngIf="GBs != null">
                                <ng-container *ngIf="GBs1 != null">
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="single-team-box card-bg-image">
                                            <div class="image">
                                                <img [src]="GBs1.ImagePath" alt="team" class="img-fluid">
                                            </div>
                                            <div class="content">


                                                <h3>{{GBs1.Name}}</h3>
                                                <span>{{GBs1.GBPosition}}</span>
                                                <span>{{GBs1.Address}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="row justify-content-center mt-4" *ngIf="GBs2 != null">
                                <ng-container *ngFor="let item of GBs2">
                                    <div class="col-lg-3 col-md-6 col-sm-6">
                                        <!-- <div class="single-team-box">
                                                <div class="image card-bg-image"></div>
                                                <div class="content">
                                                    <h3>{{item.Name}}</h3>
                                                    <span>{{item.GBDesignation}}</span>
                                                </div>
                                            </div> -->
                                        <div class="single-team-box card-bg-image">
                                            <div style="padding: 0px 10px;">
                                                <div class="image">
                                                    <img [src]="item.ImagePath" alt="team" class="img-fluid">
                                                </div>
                                                <div class="content">


                                                    <h3>{{item.Name}}</h3>
                                                    <span>{{item.GBPosition}}</span>
                                                    <span>{{item.Address}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>


                        <!-- <div class="bg-image"> -->
                        <!-- Start Page Title Area -->


                        <div class="container-fluid "
                            *ngIf="selectedItem && selectedItem !== 'governing-body' && selectedItem !== 'teacher-information' && selectedItem !== 'staff-information'">
                            <section class="subscribe-wrap-area bg-image"
                                style="background-image: url(../../../../assets/img/school/gb-all.png);margin-bottom: -250px; background-repeat: no-repeat; background-size: 100% 100%;">
                                <div class="container-fluid">
                                    <ng-container *ngIf="GBms == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>

                                    <div class="row justify-content-center mt-4">
                                        <article class="col-md-12 text-justify p-4">
                                            <div class="row justify-content-center mt-4"
                                                style="margin-top: 75px !important; margin-bottom: 20px !important;">
                                                <img alt="Message" class="img-thumbnail img-fluid"
                                                    [src]="GBms1.GBImagePath"
                                                    style="width: 100%; max-width: 220px; aspect-ratio: 4/5; object-fit: cover; border-radius: 8px; border: 5px solid #026670;">
                                            </div>
                                            <div class="row justify-content-center mt-4 message-text-container">

                                                <p style="text-align: center; font-size: 14px; line-height: 1.8; font-family: 'Li Ador Noirrit SemiBold';"
                                                    [innerHTML]="GBms1.DetailsEn">
                                                </p>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </section>
                        </div>


                        <!-- </div> -->

                        <!-- <div class="container"
                                *ngIf="selectedItem && selectedItem !== 'governing-body' && selectedItem !== 'teacher-information' && selectedItem !== 'staff-information'">
                                <ng-container *ngIf="GBms == null" class="spinner-overlay">
                                    <span class="fetching-data-text">No Data Found</span>
                                </ng-container>

                                <div class="row justify-content-center mt-4">
                                    <article class="col-md-12 text-justify p-4">
                                        <div>
                                            <img alt="Message" class="img-thumbnail img-fluid"
                                                [src]="GBms1.GBImagePath"
                                                style="float:left; height:220px; margin:0px 15px 10px 0px; width:200px; border-radius: 8px;">
                                        </div>

                                        <p style="text-align: justify; font-size: 16px; line-height: 1.8;font-family: 'Li Ador Noirrit SemiBold';"
                                            [innerHTML]="GBms1.DetailsEn">
                                        </p>
                                    </article>
                                </div>
                            </div> -->


                    </div>
                </div>
            </div>

            <br>
        </div>
        <div aria-hidden="true" *ngIf="fetchinData" class="col-lg-12 col-md-12">
            <h5 class="placeholder-glow">
                <span class="placeholder col-12" style="height: 200px;"></span>
            </h5>
        </div>
    </div>
</div>